/* eslint-disable no-console */
/* eslint-disable prefer-const */
/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Modal,
  Row,
  Spin,
  Tabs,
} from 'antd';
import { getMotivosDeReclutamiento } from 'api/catalogos/motivosReclutamiento';
import { getNivelesDeEstudios } from 'api/catalogos/nivelesDeEstudios';
import { getPlazasvistaOptimized } from 'api/catalogos/plazas';
import { getPuesto, getPuestos } from 'api/catalogos/puestos';
import { getPrioridades } from 'api/Prioridad';
import {
  getCompetenciasRequeridas,
  patchCompetenciaRequerida,
  postCompetenciaRequerida,
} from 'api/reclutamiento/competenciasRequeridasSolicitud';
import {
  getFuncionesPrincipales, patchFuncionPrincipal, postFuncionPrincipal,
} from 'api/reclutamiento/funcionesPrincipales';
import {
  getComprobantesDeEstudio,
  getSolicitudDeContratacion,
} from 'api/reclutamiento/SolicitudesDeContratacion';
import { checkToken } from 'api/utils';
import FormSubmitControls from 'components/FormSubmitControls';
import Select from 'components/Select';
import Table from 'components/Table';
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import {
  ESTATUS_ACTIVO,
} from 'utils/constants';
import { onError, onSuccess } from 'utils/handlers';

export const listadoDeVacantes = {
  permissionModel: 'solicituddecontratacion',
};

const VacantesParaHistorico = ({ permission, idVacante }) => {
  const [form] = Form.useForm();
  const { TabPane } = Tabs;

  const [plazas, setPlazas] = useState([]);
  const [puestos, setPuestos] = useState([]);
  const [comprobantesDeEstudio, setComprobantesDeEstudio] = useState([]);
  const [nivelEstudio, setNivelEstudio] = useState([]);
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState('solicitante');
  const [IsDisabledCompetenciasTab, setIsDisabledCompetenciasTab] = useState(true);
  const [IsDisabledFuncionesTab, setIsDisabledFuncionesTab] = useState(true);
  const [IsDisabledSolicitanteTab, setIsDisabledSolicitanteTab] = useState(false);
  const [IsDisabledPlazaTab, setIsDisabledPlazaTab] = useState(false);
  const [ultimaSolicitudGuardada, setUltimaSolicitudGuardada] = useState(null);
  const [competencias, setCompetencias] = useState([]);
  const [openModalComp, setOpenModalComp] = useState(false);
  const [selectedCompIndex, setSelectedCompIndex] = useState(null);
  const [formCompetencia] = Form.useForm();
  const [selectedRowKeysComp, setSelectedRowKeysComp] = useState([]);
  const [plazasFiltradas, setPlazasFiltradas] = useState([]);
  const [funcionesPrincipales, setFuncionesPrincipales] = useState([]);
  const [openModalFuncion, setOpenModalFuncion] = useState(false);
  const [selectedFuncionIndex, setSelectedFuncionIndex] = useState(null);
  const [formFuncion] = Form.useForm();
  const [motivosDeReclutamiento, setMotivosDeReclutamiento] = useState([]);

  // variables para el control de la info del solicitante:
  const [empleadoTexto, setEmpleadoTexto] = useState('');
  const [puestoTexto, setPuestoTexto] = useState('');
  const [areaTexto, setAreaTexto] = useState('');
  const [plazaTexto, setPlazaTexto] = useState('');
  const [prioridades, setPrioridades] = useState([]);

  // Variables para el control de la info de la plaza
  const [plazaPuestoTexto, setPlazaPuestoTexto] = useState('');
  const [plazaCategoriaTexto, setPlazaCategoriaTexto] = useState('');

  // FIN de funciones para la buqueda de empleados
  // Estado exclusivo para selección de filas en la tabla de Funciones Principales
  const [selectedRowKeysFuncion, setSelectedRowKeysFuncion] = useState([]);
  // NORMALIZACION DE LOS DATOS

  const catalogosCargadosRef = useRef(false);

  const fetchConceptos = async () => {
    if (catalogosCargadosRef.current) return;

    try {
      const [
        _plazas,
        _comprobantesDeEstudios,
        _nivelesDeEstudio,
        _prioridades,
        _puestos,
      ] = await Promise.all([
        getPlazasvistaOptimized(),
        getComprobantesDeEstudio(),
        getNivelesDeEstudios(),
        getPrioridades(),
        getPuestos(),
      ]);

      // Asignar los valores obtenidos
      setPrioridades(_prioridades);
      setPlazas(_plazas);
      setPuestos(_puestos);

      const _comprobantesDeEstudiosLimpios = Object.values(_comprobantesDeEstudios).filter(
        (item) => typeof item === 'object' && item.id,
      );
      setComprobantesDeEstudio(_comprobantesDeEstudiosLimpios);

      const _nivelesDeEstudioLimpios = Object.values(_nivelesDeEstudio).filter(
        (item) => typeof item === 'object' && item.id,
      );
      setNivelEstudio(_nivelesDeEstudioLimpios);

      catalogosCargadosRef.current = true;
    } catch (err) {
      onError(err);
    }
  };

  // donde ordenas:
  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      try {
        const [
          _funcionesPrincipales,
          _motivosDeReclutamiento,
        ] = await Promise.all([
          getFuncionesPrincipales(),
          getMotivosDeReclutamiento(),

        ]);

        if (mounted) {
          setFuncionesPrincipales(_funcionesPrincipales);
          setMotivosDeReclutamiento(_motivosDeReclutamiento);
        }
      } catch (error) {
        onError(error);
      } finally {
        if (mounted) setLoading(false);
      }
    };

    fetchAll();
    return () => { mounted = false; };
  }, []);

  const onClickEdit = async () => {
    try {
      setLoading(true);
      const [key] = idVacante;
      if (!key) return;
      await fetchConceptos(); // <-- carga catálogos

      const solicitud = await getSolicitudDeContratacion(key);
      if (!solicitud) return;
      // === 1. Setear textos visibles (inputs deshabilitados o de solo lectura)
      const emp = solicitud.empleado;
      setEmpleadoTexto(emp?.numero_y_nombre_completo || '');

      const area = solicitud.directorio_de_area_adscripcion;
      setAreaTexto(area?.clave_y_nombre || '');

      const { puesto } = solicitud;
      let puestoCompletoSolic = null;
      if (puesto?.id) {
        puestoCompletoSolic = await getPuesto(puesto.id);
      }

      setPuestoTexto(
        puestoCompletoSolic
          ? `${puestoCompletoSolic.clave} - ${puestoCompletoSolic.descripcion}`
          : puesto?.descripcion || '',
      );

      const categoria = solicitud.categoria_plaza;

      const { plaza } = solicitud;
      if (plaza) {
        let puestoCompletoPlaza = null;
        if (plaza.puesto_id) {
          puestoCompletoPlaza = await getPuesto(plaza.puesto_id);
        }
        setPlazaPuestoTexto(
          puestoCompletoPlaza
            ? `${puestoCompletoPlaza.clave} - ${puestoCompletoPlaza.descripcion}`
            : plaza.puesto_descripcion || '',
        );

        setPlazaCategoriaTexto(plaza.categoria_nombre || '');
        setPlazaTexto(plaza.clave_y_descripcion || '');
      } else {
        setPlazaPuestoTexto('');
        setPlazaCategoriaTexto('');
      }

      // === 2. Setear campos del formulario (IDs y valores)
      form.setFieldsValue({
        empleado: emp?.id,
        puesto: puesto?.id,
        area_adscripcion: area?.id,
        categoria: categoria?.id,
        plaza_plaza: plaza?.clave_y_descripcion,
        plaza_area: plaza.directorio_de_area_clave_y_nombre,
        plaza_puesto: plaza?.puesto_id,
        plaza_categoria: plaza?.categoria,
        nivel_estudios: solicitud.nivel_de_estudios?.id,
        comprobante_estudios: solicitud.comprobante?.id,
        numero_oficio: solicitud.no_de_oficio || undefined,
        motivo_de_reclutamiento: solicitud.motivo_de_reclutamiento?.id,
        fecha_de_solicitud: solicitud.fecha_de_solicitud
          ? moment(solicitud.fecha_de_solicitud)
          : null,

        prioridad: solicitud.prioridad?.id,
        fecha_para_ocupar_la_vacante: solicitud.fecha_para_ocupar_la_vacante
          ? moment(solicitud.fecha_para_ocupar_la_vacante)
          : null,

        //  Campos de edad (convertidos a número)
        edad_minima: solicitud.edad_minima != null ? Number(solicitud.edad_minima) : null,
        edad_maxima: solicitud.edad_maxima != null ? Number(solicitud.edad_maxima) : null,
      });

      // === 3. Habilitar tabs necesarios
      setIsDisabledCompetenciasTab(false);
      setIsDisabledFuncionesTab(false);
      setIsDisabledSolicitanteTab(false);
      setIsDisabledPlazaTab(false);

      // === 4. Mostrar modal de edición
    } catch (err) {
      onError(err);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    onClickEdit();
  }, [idVacante]);

  // REGLAS
  const requiredRule = {
    required: true,
    message: 'Este campo es obligatorio',
  };

  const rules = {
    required: [requiredRule],
    concepto: [requiredRule],
  };
  // FUNCIONES PARA LOS FORMULARIOS

  // Función para cargar las competencias
  const cargarCompetencias = async () => {
    try {
      const [solicitudId] = idVacante;
      if (!(solicitudId || ultimaSolicitudGuardada)) return;
      const response = await getCompetenciasRequeridas({ solicitud_de_contratacion: solicitudId || ultimaSolicitudGuardada });
      setCompetencias(response.results || []);
    } catch (error) {
      onError(error);
    }
  };

  // Función para cargar las funciones principales
  const cargarFuncionesPrincipales = async () => {
    try {
      const [solicitudId] = idVacante;
      if (!(solicitudId || ultimaSolicitudGuardada)) return;
      const response = await getFuncionesPrincipales({ solicitud_de_contratacion: solicitudId || ultimaSolicitudGuardada });
      setFuncionesPrincipales(response.results || []);
    } catch (error) {
      onError(error);
    }
  };

  // Efecto para cargar competencias y funciones cuando se selecciona una solicitud
  useEffect(() => {
    if (idVacante) {
      cargarCompetencias();
      cargarFuncionesPrincipales();
      setSelectedRowKeysFuncion([]); // <-- limpiar selección exclusiva de funciones
    } else {
      setCompetencias([]);
      setFuncionesPrincipales([]);
      setSelectedRowKeysFuncion([]); // <-- limpiar selección exclusiva de funciones
    }
  }, [idVacante]);

  const onClickEditarCompetencia = () => {
    const selected = competencias.find((c) => c.id === selectedRowKeysComp[0]);
    if (selected) {
      formCompetencia.setFieldsValue(selected);
      setSelectedCompIndex(competencias.findIndex((c) => c.id === selectedRowKeysComp[0]));
      setOpenModalComp(true);
    }
  };

  const handleGuardarCompetencia = async (values) => {
    try {
      const [solicitudId] = idVacante;
      if (!(solicitudId || ultimaSolicitudGuardada)) {
        onError({ mensaje: 'No se ha seleccionado una solicitud' });
        return;
      }
      const payload = {
        competencia: values.competencia?.trim(),
        porcentaje: parseFloat(values.porcentaje),
        solicitud_de_contratacion: solicitudId || ultimaSolicitudGuardada,
        estados_globales: ESTATUS_ACTIVO,
      };

      let result = null;

      if (selectedCompIndex !== null) {
        const { id } = competencias[selectedCompIndex];
        result = await patchCompetenciaRequerida(id, payload);
      } else {
        result = await postCompetenciaRequerida(payload);
      }
      if (result?.id) {
        setOpenModalComp(false);
        formCompetencia.resetFields();
        setSelectedCompIndex(null);
        onSuccess({ mensaje: 'Competencia guardada correctamente' });
      }
      await cargarCompetencias();
      setOpenModalComp(false);
    } catch (error) {
      onError(error);
    }
  };

  const handleCancelarModalComp = () => {
    setOpenModalComp(false);
    formCompetencia.resetFields();
    setSelectedCompIndex(null);
  };

  const handleOnRowClickComp = (record) => {
    setSelectedRowKeysComp([record.id]);
    formCompetencia.setFieldsValue(record);
  };

  const rowSelectionComp = {
    selectedRowKeys: selectedRowKeysComp,
    onChange: (newSelectedRowKeys) => setSelectedRowKeysComp(newSelectedRowKeys),
    type: 'radio',
  };

  // FUNCIONES PARA FUNCIONES PRINCIPALES ---------------------------------

  const funcionId = Form.useWatch('id', formFuncion);

  const onClickEditarFuncion = async () => {
    const selected = funcionesPrincipales.find((f) => f.id === selectedRowKeysFuncion[0]);
    if (selected) {
      formFuncion.setFieldsValue(selected);
      setSelectedFuncionIndex(funcionesPrincipales.findIndex((f) => f.id === selected.id));
      setOpenModalFuncion(true);
    }
  };

  // AQUI REFRESCA LA TABLA DE FUNCIONES PRINCIPALES
  const handleGuardarFuncionPrincipal = async (values) => {
    try {
      const [solicitudId] = idVacante;
      if (!(solicitudId || ultimaSolicitudGuardada)) {
        onError({ mensaje: 'No se ha seleccionado una solicitud' });
        return;
      }
      const payload = {
        ...values,
        solicitud_de_contratacion: solicitudId || ultimaSolicitudGuardada,
        estados_globales: ESTATUS_ACTIVO,
      };
      let result = null;
      if (selectedFuncionIndex !== null) {
        const { id } = funcionesPrincipales[selectedFuncionIndex];
        result = await patchFuncionPrincipal(id, payload);
      } else {
        result = await postFuncionPrincipal(payload);
      }
      if (result) {
        setOpenModalFuncion(false); // Cierra el modal primero
        formFuncion.resetFields(); // Limpia el formulario
        setSelectedFuncionIndex(null);
        await cargarFuncionesPrincipales(); // Refresca la tabla después
        onSuccess({ mensaje: 'Función principal guardada correctamente' });
      }
    } catch (error) {
      onError(error);
    }
  };

  const handleCancelarModalFuncion = () => {
    formFuncion.resetFields();
    setOpenModalFuncion(false);
    setSelectedFuncionIndex(null);
    setSelectedRowKeysFuncion([]);
  };

  const rowSelectionFuncion = {
    selectedRowKeys: selectedRowKeysFuncion,
    onChange: (newSelectedRowKeys) => setSelectedRowKeysFuncion(newSelectedRowKeys),
    type: 'radio',
  };
  // Cuando seleccionas un área
  const handleAreaChange = (areaId) => {
    // Filtrar solo plazas disponibles de esa área
    const disponibles = plazas.filter(
      (p) => p.directorio_area_id === areaId && p.estado_plaza === 'DISPONIBLE',
    );

    setPlazasFiltradas(disponibles);

    // Reset de la plaza seleccionada
    form.setFieldsValue({ plaza_plaza: null });
    setPlazaPuestoTexto('');
    setPlazaCategoriaTexto('');
  };

  // Cuando seleccionas una plaza
  const handlePlazaChange = async (plazaId) => {
    const plazaSeleccionada = plazas.find((p) => p.id === plazaId);

    if (plazaSeleccionada) {
      form.setFieldsValue({
        plaza_plaza: plazaSeleccionada.id,
        plaza_puesto: plazaSeleccionada.puesto_id,
        plaza_categoria: plazaSeleccionada.categoria_de_puesto_id,
        tipo_empleado: plazaSeleccionada.tipo_de_empleado_id,
      });

      // Fetch puntual
      let puestoCompleto = null;
      if (plazaSeleccionada.puesto_id) {
        puestoCompleto = await getPuesto(plazaSeleccionada.puesto_id);
      }

      setPlazaPuestoTexto(
        puestoCompleto
          ? `${puestoCompleto.clave} - ${puestoCompleto.descripcion}`
          : plazaSeleccionada.puesto || '',
      );

      setPlazaCategoriaTexto(plazaSeleccionada.categoria_de_empleado || '');
    } else {
      form.resetFields(['plaza_plaza', 'plaza_puesto', 'plaza_categoria', 'tipo_empleado']);
      setPlazaPuestoTexto('');
      setPlazaCategoriaTexto('');
    }
  };

  const ordenarPorClave = (a, b, campo) => {
    const claveA = a[campo]?.split(' - ')[0] || '';
    const claveB = b[campo]?.split(' - ')[0] || '';

    const arrA = claveA.split('.').map((n) => parseInt(n, 10) || 0);
    const arrB = claveB.split('.').map((n) => parseInt(n, 10) || 0);

    const len = Math.max(arrA.length, arrB.length);

    for (let i = 0; i < len; i += 1) {
      const valA = arrA[i] ?? 0;
      const valB = arrB[i] ?? 0;
      if (valA !== valB) return valA - valB;
    }

    return 0;
  };

  // Define handleOnRowClickFuncion for the Table in Funciones Principales tab
  const handleOnRowClickFuncion = (record) => {
    setSelectedRowKeysFuncion([record.id]);
    formFuncion.setFieldsValue(record);
  };

  // === OPCIONES DEL SOLICITANTE CORREGIDAS ===

  // 1. Obtener áreas únicas desde las plazas
  const opcionesAreas = [...new Map(
    plazas.map((p) => [p.directorio_area_id, {
      id: p.directorio_area_id,
      descripcion: p.directorio_area_clave_y_nombre,
      clave: p.directorio_area_clave_y_nombre?.split(' - ')[0] || '', // clave numérica
    }]),
  ).values()];

  // 2. Ordenarlas por clave numérica
  opcionesAreas.sort((a, b) => {
    const claveA = a.clave.split('.').map((x) => parseInt(x, 10));
    const claveB = b.clave.split('.').map((x) => parseInt(x, 10));
    const len = Math.max(claveA.length, claveB.length);

    for (let i = 0; i < len; i += 1) {
      const valA = claveA[i] ?? 0;
      const valB = claveB[i] ?? 0;
      if (valA !== valB) return valA - valB;
    }
    return 0;
  });

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Col xs={24}>
          {/* Modal Agregar/Editar */}
          <Form
            form={form}
            layout="vertical"
            name="vacantes"
            initialValues={{
              estados_globales: ESTATUS_ACTIVO,
              is_active: true,
              vigencia_inicial: moment(),
            }}
          >
            <Tabs activeKey={activeTab} onChange={setActiveTab} destroyInactiveTabPane={false}>
              {/* TABS */}

              <TabPane tab="Solicitante" key="solicitante" disabled={IsDisabledSolicitanteTab}>
                <Row gutter={16}>
                  {/* Estos guardan los IDs */}
                  <Form.Item name="empleado" hidden><Input disabled /></Form.Item>
                  <Form.Item name="puesto" hidden><Input disabled /></Form.Item>
                  <Form.Item name="area_adscripcion" hidden><Input disabled /></Form.Item>
                  <Form.Item name="categoria" hidden><Input disabled /></Form.Item>
                  <Form.Item name="plaza" hidden><Input disabled /></Form.Item>

                  {/* Fecha de Solicitud */}
                  <Col xs={24} sm={12}>
                    <Form.Item label="Fecha de Solicitud">
                      <Input disabled value={moment().format('DD-MM-YYYY')} />
                    </Form.Item>
                  </Col>

                  {/* Nombre del Responsable del Área */}
                  <Col xs={24} sm={12}>
                    <Form.Item label="Nombre">
                      <Input.Group compact>
                        <Input
                          readOnly
                          value={empleadoTexto}
                          style={{ width: 'calc(100% - 40px)' }}
                          disabled
                        />
                      </Input.Group>
                    </Form.Item>
                  </Col>

                  <Col xs={24} sm={12}>
                    <Form.Item label="Área">
                      <Input value={areaTexto} disabled />
                    </Form.Item>
                  </Col>

                  <Col xs={24} sm={12}>
                    <Form.Item label="Puesto">
                      <Input value={puestoTexto} disabled />
                    </Form.Item>
                  </Col>

                  <Col xs={24} sm={12}>
                    <Form.Item label="Plaza">
                      <Input value={plazaTexto} disabled />
                    </Form.Item>
                  </Col>

                  {/* <Col xs={24} sm={12}>
                      <Form.Item label="Categoría">
                        <Input value={categoriaTexto} disabled />
                      </Form.Item>
                    </Col> */}
                </Row>
              </TabPane>
              {/* plaza */}
              <TabPane tab="Plaza" key="plaza">

                <Form.Item name="plaza_area" hidden><Input disabled /></Form.Item>
                <Form.Item name="plaza_puesto" hidden><Input disabled /></Form.Item>
                <Form.Item name="plaza_categoria" hidden><Input disabled /></Form.Item>

                {/* Área */}
                <Row gutter={16}>
                  <Col xs={24} sm={12}>
                    <Form.Item
                      name="plaza_area"
                      label="Área"
                      rules={[{ required: true, message: 'El área es obligatoria' }]}
                    >
                      <Select
                        dataSource={Array.from(
                          new Map(
                            plazas
                              .filter((p) => p.estado_plaza === 'DISPONIBLE')
                              .map((p) => [
                                p.directorio_area_id,
                                {
                                  id: p.directorio_area_id,
                                  descripcion: p.directorio_area_clave_y_nombre,
                                },
                              ]),
                          ).values(),
                        ).sort((a, b) => ordenarPorClave(a, b, 'descripcion'))} //  ordenar por clave
                        keyProp="id"
                        labelProp="descripcion"
                        render={(a) => a.descripcion}
                        showSearch
                        onChange={handleAreaChange}
                        disabled
                      />
                    </Form.Item>
                  </Col>

                  {/* Plaza */}
                  <Col xs={24} sm={12}>
                    <Form.Item
                      name="plaza_plaza"
                      label="Plaza"
                      rules={rules.required}
                    >
                      <Select
                        dataSource={[...plazasFiltradas].sort((a, b) => ordenarPorClave(a, b, 'clave_y_descripcion'))} //  ordenar por clave
                        keyProp="id"
                        labelProp="clave_y_descripcion"
                        render={(p) => p?.clave_y_descripcion}
                        showSearch
                        onChange={handlePlazaChange}
                        disabled
                      />
                    </Form.Item>
                  </Col>

                  {/* PUESTO */}
                  <Col xs={24} sm={12}>
                    <Form.Item label="Puesto">
                      <Input value={plazaPuestoTexto} disabled />
                    </Form.Item>
                  </Col>

                  {/* TIPO DE EMPLEADO */}
                  <Col xs={24} sm={12}>
                    <Form.Item label="Tipo de Empleado">
                      <Input value={plazaCategoriaTexto} disabled />
                    </Form.Item>
                  </Col>

                  {/* Número de Plazas Requeridas */}
                  {/* <Col xs={24} sm={12}>
                      <Form.Item
                        name="numero_plazas"
                        label="Número de Plazas Requeridas"
                        rules={[{ required: true, message: 'Ingresa el número de plazas' }]}
                      >
                        <InputNumber min={1} style={{ width: '100%' }} placeholder="Número entero" />
                      </Form.Item>
                    </Col> */}

                  {/* Escolaridad Mínima */}
                  <Col xs={24} sm={12}>
                    <Form.Item
                      name="nivel_estudios"
                      label="Escolaridad Mínima"
                      rules={[{ required: true, message: 'Selecciona la escolaridad mínima' }]}
                    >
                      <Select
                        labelProp="nombre"
                        keyProp="id"
                        dataSource={nivelEstudio}
                        render={(item) => `${item?.nombre}`}
                        disabled
                      />
                    </Form.Item>
                  </Col>

                  {/* Comprobante de Estudios */}
                  <Col xs={24} sm={12}>
                    <Form.Item
                      name="comprobante_estudios"
                      label="Comprobante de Estudios"
                      rules={[{ required: true, message: 'Selecciona un comprobante de estudios' }]}
                    >
                      <Select
                        labelProp="nombre"
                        keyProp="comprobantesDeEstudio"
                        dataSource={comprobantesDeEstudio}
                        render={(item) => `${item?.nombre}`}
                        disabled
                      />
                    </Form.Item>
                  </Col>

                  {/* Edad Mínima */}
                  <Col xs={24} sm={12}>
                    <Form.Item
                      name="edad_minima"
                      label="Edad Mínima"
                      rules={[{ required: true, message: 'Ingresa la edad mínima' }]}
                    >
                      <InputNumber min={0} style={{ width: '100%' }} disabled />
                    </Form.Item>
                  </Col>

                  {/* Edad Máxima */}
                  <Col xs={24} sm={12}>
                    <Form.Item
                      name="edad_maxima"
                      label="Edad Máxima"
                      rules={[{ required: true, message: 'Ingresa la edad máxima' }]}
                    >
                      <InputNumber min={0} style={{ width: '100%' }} disabled />
                    </Form.Item>
                  </Col>

                  {/* No. de Oficio */}
                  <Col xs={24} sm={12}>
                    <Form.Item
                      name="numero_oficio"
                      label="No. de Oficio de Solicitud"
                      rules={[{ required: true, message: 'Ingresa el número de oficio' }]}
                    >
                      <Input disabled />
                    </Form.Item>
                  </Col>

                  {/* Motivo */}
                  <Col xs={24} sm={12}>
                    <Form.Item
                      name="motivo_de_reclutamiento"
                      label="Motivo de Solicitud"
                      rules={[{ required: true, message: 'Selecciona un motivo de reclutamiento' }]}
                    >
                      <Select
                        labelProp="nombre"
                        keyProp="id"
                        render={(item) => item.nombre}
                        dataSource={motivosDeReclutamiento}
                        disabled
                      />
                    </Form.Item>
                  </Col>

                  {/* Prioridad */}
                  <Col xs={24} sm={12}>
                    <Form.Item
                      name="prioridad"
                      label="Prioridad"
                      rules={[{ required: true, message: 'Selecciona la prioridad' }]}
                    >
                      <Select
                        dataSource={prioridades}
                        keyProp="id"
                        labelProp="descripcion"
                        render={(item) => item.descripcion}
                        showSearch
                        disabled
                      />
                    </Form.Item>
                  </Col>

                  {/* Fecha para ocupar la vacante */}
                  <Col xs={24} sm={12}>
                    <Form.Item
                      name="fecha_para_ocupar_la_vacante"
                      label="Fecha para Ocupar la Vacante"
                      rules={[{ required: true, message: 'Selecciona la fecha' }]}
                    >
                      <DatePicker
                        style={{ width: '100%' }}
                        format="YYYY-MM-DD"
                        placeholder={null}
                        disabled
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row />
              </TabPane>

              <TabPane
                tab="Competencias Requeridas"
                key="competencias"
                disabled={IsDisabledCompetenciasTab}
              >
                <Row gutter={16}>

                  <Col xs={24}>
                    <Table
                      cols={[
                        {
                          titleText: 'No.',
                          dataIndex: 'numero',
                          key: 'numero',
                          width: 70,
                        },
                        {
                          titleText: 'Competencias',
                          dataIndex: 'competencia',
                          key: 'competencia',
                          width: 120,
                        },
                        {
                          titleText: 'Porcentaje',
                          dataIndex: 'porcentaje',
                          key: 'porcentaje',
                          width: 90,
                          render: (val) => `${val}%`,
                        },
                      ]}
                      data={competencias}
                      rowSelection={rowSelectionComp}
                      handleOnRowClick={handleOnRowClickComp}
                      permission={permission}
                      allowExportPDF={false}
                      controls={{
                        onClickExpand: onClickEditarCompetencia,
                      }}
                    />
                  </Col>
                </Row>

                <Modal
                  open={openModalComp}
                  footer={null}
                  // title={selectedCompIndex !== null ? 'Editar Competencia' : 'Agregar Competencia'}
                  title={(
                    <FormSubmitControls
                      label={`${selectedCompIndex !== null ? 'Editar' : 'Agregar'} Agregar Competencia`}
                      onFinish={() => formCompetencia.submit()}
                      onCancel={handleCancelarModalComp}
                      loading={loading}
                    />
                  )}
                  onCancel={handleCancelarModalComp}
                  width="40%"
                >
                  <Form
                    form={formCompetencia}
                    layout="vertical"
                    onFinish={handleGuardarCompetencia}
                  >
                    <Row gutter={16}>
                      {/* <Col xs={24}>
                          <Form.Item label="No.">
                            <Input disabled />
                            <small style={{ color: '#fa8c16' }}>Numeración automática</small>
                          </Form.Item>
                        </Col> */}

                      <Col xs={24}>
                        <Form.Item
                          name="competencia"
                          label="Competencia"
                          rules={[
                            {
                              required: true,
                              message: 'La competencia es obligatoria',
                              // primero quitamos espacios para que no pase un "   "
                              transform: (value) => (typeof value === 'string' ? value.trim() : value),
                            },
                            { max: 500, message: 'Máximo 500 caracteres' },
                          ]}
                          validateTrigger={['onChange', 'onBlur']}
                        >
                          <Input.TextArea
                            rows={3}
                            disabled
                          />
                          {/* <small style={{ color: '#fa8c16' }}>Campo alfanumérico de captura libre</small> */}
                        </Form.Item>
                      </Col>

                      <Col xs={24}>
                        <Form.Item
                          name="porcentaje"
                          label="Porcentaje"
                          valuePropName="value"
                          getValueFromEvent={(e) => {
                            // Asegura que siempre se guarde como número
                            if (typeof e === 'string') return parseFloat(e);
                            return e;
                          }}
                          rules={[
                            { required: true, message: 'El porcentaje es obligatorio' },
                            {
                              type: 'number',
                              min: 0,
                              max: 100,
                              message: 'El porcentaje debe estar entre 0 y 100',
                            },
                          ]}
                        >
                          <InputNumber
                            min={0}
                            max={100}
                            step={0.01}
                            style={{ width: '100%' }}
                            stringMode
                            disabled
                          />
                        </Form.Item>
                      </Col>

                      {/* <Col xs={24} style={{ textAlign: 'right' }}>
                          <Button onClick={handleCancelarModalComp} style={{ marginRight: 8 }}>
                            Cancelar
                          </Button>
                          <Button type="primary" htmlType="submit">
                            Guardar
                          </Button>
                        </Col> */}
                    </Row>
                  </Form>
                </Modal>
              </TabPane>

              <TabPane tab="Funciones Principales" key="funciones" disabled={IsDisabledFuncionesTab}>
                <Row gutter={16}>
                  <Col xs={24}>
                    <Form.Item
                      name="observaciones"
                      label="Observaciones"
                    >
                      <Input.TextArea rows={2} disabled />
                    </Form.Item>
                  </Col>

                  <Col xs={24}>
                    <Table
                      cols={[
                        {
                          titleText: 'No.',
                          dataIndex: 'id',
                          key: 'id',
                          width: 80,
                        },
                        {
                          titleText: 'Funciones Principales',
                          dataIndex: 'funcion',
                          key: 'funcion',
                        },
                      ]}
                      data={funcionesPrincipales}
                      rowSelection={rowSelectionFuncion}
                      handleOnRowClick={handleOnRowClickFuncion}
                      permission={permission}
                      allowExportPDF={false}
                      controls={{
                        onClickExpand: onClickEditarFuncion,
                      }}
                    />
                  </Col>
                </Row>

                {/* Modal Función */}
                <Modal
                  open={openModalFuncion}
                  footer={null}
                  // title={selectedFuncionIndex !== null ? 'Editar Función Principal' : 'Agregar Función Principal'}
                  title={(
                    <FormSubmitControls
                      label={`${selectedFuncionIndex !== null ? 'Editar' : 'Agregar'} Agregar Función Principal`}
                      onFinish={() => formFuncion.submit()}
                      onCancel={handleCancelarModalFuncion}
                      loading={loading}
                    />
                  )}
                  onCancel={handleCancelarModalFuncion}
                  width="40%"
                >
                  <Form
                    form={formFuncion}
                    layout="vertical"
                    onFinish={handleGuardarFuncionPrincipal}
                  >
                    <Row gutter={16}>
                      {/* ID (si ya existe) */}
                      {funcionId && (
                        <Col xs={24}>
                          <Form.Item label="No.">
                            <Input value={funcionId} disabled />
                          </Form.Item>
                        </Col>
                      )}

                      {/* Función */}
                      <Col xs={24}>
                        <Form.Item
                          name="funcion"
                          label="Función"
                          rules={[
                            { required: true, message: 'Campo obligatorio' },
                            {
                              validator: (_, value) => (value && value.trim() !== ''
                                ? Promise.resolve()
                                : Promise.reject(new Error('Campo obligatorio'))),
                            },
                          ]}
                        >
                          <Input.TextArea rows={2} disabled />
                        </Form.Item>
                      </Col>

                      {/* <Col xs={24} style={{ textAlign: 'right' }}>
                          <Button onClick={handleCancelarModalFuncion} style={{ marginRight: 8 }}>
                            Cancelar
                          </Button>
                          <Button htmlType="submit">
                            Guardar
                          </Button>
                        </Col> */}
                    </Row>
                  </Form>
                </Modal>
              </TabPane>

            </Tabs>
            {/* Botón oculto para submit por Enter */}
            <Form.Item hidden>
              <Button htmlType="submit" />
            </Form.Item>
          </Form>
        </Col>

      </Spin>
    </Row>
  );
};

export default VacantesParaHistorico;
